import { Store, SerializedData } from "bernie-core";
import { observable } from "mobx";
import { JumplinkItem } from "components/flexComponents/Jumplinks/Jumplinks";

export class DXStore extends Store {
  @observable
  public isScrolledPastThreshold: boolean = false;

  @observable
  public jumplinksArray: JumplinkItem[] = [];

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
